"use client";
import { useTranslations } from "@/i18n/client";
import { useAuth } from "@/lib/centra/hooks/useAuth";
import { useSearchParams } from "next/navigation";
import { ACCOUNT_TABS } from "./consts";
import styles from "./index.module.css";

export const ActiveHeader = () => {
  const { user, token } = useAuth();
  const searchParams = useSearchParams();
  const activeTab = searchParams.get("tab");
  const t = useTranslations("myAccount.accountPage");
  if (!token) return null;

  const welcomeHeader = t("welcomeUser", {
    name: user?.firstName || "",
  });

  switch (activeTab) {
    case ACCOUNT_TABS.overview:
      return <h1 className={styles.heading}>{welcomeHeader}</h1>;
    case ACCOUNT_TABS.orderHistory:
      return <h1 className={styles.heading}>{t("tabs.orderHistory")}</h1>;
    case ACCOUNT_TABS.favourites:
      return <h1 className={styles.heading}>{t("tabs.favourites")}</h1>;
    case ACCOUNT_TABS.accountSettings:
      return <h1 className={styles.heading}>{t("tabs.accountSettings")}</h1>;
    default:
      return <h1 className={styles.heading}>{welcomeHeader}</h1>;
  }
};
